import PtoTemplateNotes from './PtoTemplateNotes'

export default PtoTemplateNotes
